<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">添加项目经历</span>
      </p>
      <p style="padding-right: 2rem;color: #FFFFFF ">删除</p>
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">项目名称</p>
        <p> <input class="inforNameInput" type="text" v-model="data.proname" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">项目描述</p>
        <p >
          <textarea style="width: 100%;height: 5rem"  v-model="data.prodescription" placeholder="请填写"></textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">你的成就</p>
        <p >
          <textarea style="width: 100%;height: 5rem"  v-model="data.dutydescription" placeholder="请填写"></textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">项目时间</p>
        <p style="display: flex"><input class="inforTime" v-model="data.starttime" type="text" value="2014.08"><span>--</span>
          <input class="inforTime" v-model="data.endtime" type="text" value="2015.09"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">项目链接</p>
        <p><input class="inforNameInput"  v-model="data.proname" type="text" value="www.baidu.com"></p>
      </div>
      <div>

      </div>
      <div class="inforName">
        <van-button style="width: 100%;margin: 0 auto" type="primary" @click="addProjecter()">保存</van-button>

      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        data:{
          proname:"",
          prodescription:'',
          dutydescription:'',
          starttime:'',
          endtime:"",
          projecturl:''
        }
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      addProjecter(){
        console.log(this.data)
        this.$api.addProject({
          "data[proname]": this.data.proname,
          "data[prodescription]": this.data.prodescription,
          "data[dutydescription]": this.data.dutydescription,
          "data[starttime]": this.data.starttime,
          "data[endtime]": this.data.endtime,
          "data[projecturl]": this.data.projecturl,
          "data[resumeid]":this.$route.params.id

        }).then(res=>{
          this.$router.push("/editResume")
        }).catch(err=>{
        })
      },
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/addProject.vue